
let port = null
//串口目前是打开状态
let serialOpen = false
let reader = null
let cardNo = ''
//分包合并时间
let timeOut = 50
//串口缓存数据
let serialData = ''
//串口分包合并时钟
let serialTimer = null

var reading = false

// 全局串口设备拔出事件
navigator.serial.ondisconnect = (event) => {
	port = null
	serialOpen = false
	reader = null
	cardNo = ''
	timeOut = 50
	serialData = ''
	serialTimer = null
	reading = false
}

// 读取数据
async function cardReaderRead() {
	while (serialOpen && port.readable) {
		reader = port.readable.getReader();
		try {
			while (true) {
				const { value, done } = await reader.read();
				if (done) {
					break;
				}
				// 需要特别注意的是：实际使用中即使对端是按一个个包发送的串口数据，接收时收到的也可能是分多段收到的
				let array = new Uint8Array(value); // event.data.buffer就是接收到的inputreport包数据了
				let hexstr = "";
				for (const data of array) {
					hexstr += (Array(2).join(0) + data.toString(16).toLowerCase()).slice(-2); // 将字节数据转换成（XX ）形式字符串
				}
				// console.log("读取指令:"+hexstr);
				// console.log("读取卡号:"+hexstr.replace(/\s+/g, "").slice(-12, -4));
				// cardNo = hexstr.replace(/\s+/g, "").slice(-12, -4)
				serialData += hexstr
				clearTimeout(serialTimer)
				serialTimer = setTimeout(() => {
					// console.log(serialData)
					reading = false
				}, 50)
			}
			
		} catch (e) {
			console.log(e);
		} finally {
			reader.releaseLock();
		}
	}
	await port.close(); // 关闭串口
	console.log("Port closed.");
}

function getOutputData(e) {
	let outputDatastr = e.replace(/\s+/g, ""); // 去除所有空白字符
	if (outputDatastr.length % 2 == 0 && /^[0-9a-fA-F]+$/.test(outputDatastr)) {
		// 获取字节数组长度
		const byteLength = outputDatastr.length / 2;
		// 创建字节数组
		const outputData = new Uint8Array(byteLength);
		// 将字符串转成字节数组数据
		for (let i = 0; i < byteLength; i++) {
			outputData[i] = parseInt(outputDatastr.substr(i * 2, 2), 16);
		}
		// 返回数据
		return outputData;
	} else {
		throw "Data is not even or 0-9、a-f、A-F";
	}
}

//计算卡密码
function getPwd(cardId) {
	let pwd1 = ('0' + (parseInt(cardId.substr(6,2), 16) + parseInt(cardId.substr(4,2), 16) + parseInt('22', 16)).toString(16)).slice(-2)
	let pwd2 = ('0' + (parseInt(cardId.substr(2,2), 16) + parseInt(cardId.substr(0,2), 16) + parseInt('33', 16)).toString(16)).slice(-2)
	let pwd3 = ('0' + ((parseInt(cardId.substr(2,2), 16) >> 4) + (parseInt(cardId.substr(0,2), 16) >> 2)).toString(16)).slice(-2)
	let pwd4 = ('0' + ((parseInt(cardId.substr(6,2), 16) >> 1) + (parseInt(cardId.substr(4,2), 16) >> 3)).toString(16)).slice(-2)
	let pwd5 = ('0' + ((parseInt(cardId.substr(6,2), 16) + parseInt(cardId.substr(4,2), 16) + parseInt(cardId.substr(2,2), 16)) >> 1).toString(16)).slice(-2)
	let pwd6 = ('0' + ((parseInt(cardId.substr(6,2), 16) >> 7) + parseInt(cardId.substr(2,2), 16)).toString(16)).slice(-2)
	return pwd1 + pwd2 + pwd3 + pwd4 + pwd5 + pwd6
}

//计算校验
function getVerif(data) {
	let sum = 0;
	for(let i=0; i<data.length; i=i+2) {
		sum += parseInt(data.substr(i, 2), 16)
	}
	str = ('0' + (sum.toString(16))).slice(-2)
	return str;
}
	

export default{
	reader: reader,
	cardNo: cardNo,
	
	//获取当前连接的设备
	getPort: (e) => {
		return port
	},
	
	getCardNo: (e) => {
		return cardNo
	},
	getSerialData: (e) => {
		return serialData
	},
	getReading: (e) =>{
		return reading
	},
	
	//初始化
	cardReaderIni: async(e) => {
		if (port == null) {
			try {
				port = await navigator.serial.requestPort()
				await port.open({baudRate: 9600})
				serialOpen = true
				cardReaderRead()
			} catch (e) {
				// console.log(e)
			}
			console.log('设备新链接')
		} else {
			console.log('设备已连接');
		}
	},
	
	// getOutputData: (e) => {
	//     let outputDatastr = e.replace(/\s+/g, ""); // 去除所有空白字符
	//     if (outputDatastr.length % 2 == 0 && /^[0-9a-fA-F]+$/.test(outputDatastr)) {
	//         // 获取字节数组长度
	//         const byteLength = outputDatastr.length / 2;
	//         // 创建字节数组
	//         const outputData = new Uint8Array(byteLength);
	//         // 将字符串转成字节数组数据
	//         for (let i = 0; i < byteLength; i++) {
	//             outputData[i] = parseInt(outputDatastr.substr(i * 2, 2), 16);
	//         }
	//         // 返回数据
	//         return outputData;
	//     } else {
	//         throw "Data is not even or 0-9、a-f、A-F";
	//     }
	// },
	
	
	getCardId: async(e) => {
		serialData = ''
		reading = true
		const writer = port.writable.getWriter()
		await writer.write(getOutputData('ee012300dd'))
		writer.releaseLock();
	},
	
	//设置卡，相当于设置卡类型
	setPwd: async(cardId) => {
		console.log("id" + cardId);
		// let cardId = '53c3c32a'
		let pwd = getPwd(cardId)
		serialData = ''
		reading = true
		const writer = port.writable.getWriter()
		//先读卡
		await writer.write(getOutputData('ee1124' + pwd + '342b' + pwd + '342b' + '0fdd'))
		// console.log('卡密码：' + 'ee1124' + pwd + '342b' + pwd + '342b' + '0fdd');
		// await writer.write(getOutputData('ee1124' + pwd + 'c460' + pwd + 'c460' + '0fdd'))
		// console.log('卡密码：' + 'ee1124' + pwd + 'c460' + pwd + 'c460' + '0fdd');
		writer.releaseLock();
	},
	//设置扇区
	setSq: async() => {
		serialData = ''
		reading = true
		const writer = port.writable.getWriter()
		//先读卡
		await writer.write(getOutputData('ee0226082edd'))//8扇区
		// await writer.write(getOutputData('ee0226092edd'))
		writer.releaseLock();
	},
	
	//设置卡类型
	setType: async(type) => {
		console.log('leixing:' + type)
		//默认用户卡
		let carType = '18'
		switch(type) {
			case 4:
				carType = '1f'
				break;
			case 5:
				carType = '22'
				break;
		}
		// let cardId = '53c3c32a'
		serialData = ''
		reading = true
		const writer = port.writable.getWriter()
		//写卡
		// console.log('ee3328080000' + carType + '00000000000000000000000000000000000000000000000000000000000000000000000000000000000000000070d9dd');
		await writer.write(getOutputData('ee3328080000' + carType + '00000000000000000000000000000000000000000000000000000000000000000000000000000000000000000070d9dd'))
		// await writer.write(getOutputData('ee3328090000' + carType + '00000000000000000000000000000000000000000000000000000000000000000000000000000000000000000070d9dd'))
		
		writer.releaseLock();
	},
	
	

	
}